export default {
  namespaced: true,
  actions: {
    sendLyticsActivities: (context, activities) => {
      activities.forEach(activity => sendLyticsActivity(activity));
    },
  },
};

const sendLyticsActivity = activity => {
  activity.cmds.forEach(cmd => {
    sendLyticsCmd(activity.js, cmd);
  });
};

const sendLyticsCmd = (js, cmd) => {
  const tracker = js.reduce((accumulator, fn) => accumulator?.[fn], window);
  if (!tracker) return;

  tracker.apply(this, cmd);
};
